import { AbstractControl, ValidationErrors } from "@angular/forms";

export class ValidationHelper {
    emailValidator(constrol: AbstractControl): ValidationErrors | null {
        if (!constrol.value || !constrol.value.includes('@')) return null;
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/.test(constrol.value) ? { email: true } : null;
    }

    static checkControllerErrors(controller: AbstractControl): string[] {
        if (controller.errors) {
            const errors = Object.keys(controller.errors);
            if (errors.length > 0) {
                return errors.map(error => this.validationMessageList[error]);
            }
        }

        return [];
    }

    static get validationMessageList() {
        return {
            required: 'validation.required',
            email: 'validation.email',
            minlength: 'validation.minlength',
            maxlength: 'validation.maxlength',
            min: 'validation.min',
            max: 'validation.max',
            password: 'validation.password',
            passwordMatch: 'validation.passwordMatch',
            pattern: 'validation.pattern'
        }
    }
}
